import { Component } from '@angular/core';

@Component({
  selector: 'app-title',
  template: `
    <div class="flex align-items-center p-3">
      <span class="text-primary font-semibold text-xl md:text-2xl">
        <ng-content></ng-content>
      </span>
    </div>
  `,
})
export class TitleComponent {}
